import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserInfoService } from 'app/BaseFramework/core/http/user-info.service';
import * as moment from 'moment/moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';
import { ApiRequestService, CommonUtilty, AppMetadataHandler } from 'app'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AngularEditorConfig } from '@kolkov/angular-editor';
export class messageDO {
  message = null
  name = null;
  guid = null;
  datetime = null;
  content = null;
  author = null;
  avatar = null;
  displayTime = null;
  isRemarksFor = null;
  isRemarksBy = null;
  status = null;
  isMsgChainEnd = false
  showChaser: false
  conversations: any = []
}

@Component({
  selector: 'app-collaboration',
  templateUrl: './collaboration.component.html',
  styleUrls: ['./collaboration.component.scss']
})
export class CollaborationComponent {
 _currentComponentName = "CollaborationComponent"
 transactionGuid = null;
  private _inputDataForEdit = null;
  _IO = null
  messageArray = []
  dataList: any = []


  @Output() componentOutput = new EventEmitter<object>();
  @Input()
  set inputDataForEdit(value: any) {
    if (value) {
      this._inputDataForEdit = value
      this.ServerToUITransform(this._inputDataForEdit)
    }
  }

  get inputDataForEdit() {
    return this._inputDataForEdit
  }

  @Input()
  set IO(value) {
    if (value) {
      this._IO = value
      this.getCollaborationNum(value)
    }
  }
  @Input() transactionState: string;

  constructor(private userInfoService: UserInfoService,
    private apiRequestService: ApiRequestService,
    private router: Router,
    public commonUtilty: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    private msg: NzMessageService,
    public sanitizer: DomSanitizer) { }

  ngOnInit() { }

  lookupsToBind = ['roleUsers', 'collaborationPartyCd', 'followupStatusCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  getCurrentComponentName(): string { return `${this._currentComponentName}` }

  data: any[] = [];
  submitting = false;
  user = {
    author: this.userInfoService.getUserId(),
    avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'
  };
  inputValue = '';
  notes = []

  replyToEnquiry(currentCollabGuid, collaborationTypeCd, index?) {
    let obj = { collaborationDO: {}, documents: [] };
    let collabDO = this.inputDataForEdit.find(item => item.collaborationDO.guid == currentCollabGuid)
    this.submitting = true
    if (collabDO) {
      obj.collaborationDO = collabDO.collaborationDO
      this.inputValue = this.notes[index]
      let dataObj = {
        "description": this.inputValue,
        "createdUser": this.user ? this.user.author : '',
        "createdDt": new Date().getTime()
      }
      if (this.commonUtilty.isArrayIterable(obj.collaborationDO['conversations'])) {
        obj.collaborationDO['conversations'].push(dataObj)
      }
      else obj.collaborationDO['conversations'] = [dataObj]
      let URL = 'collaborationSave';
      this.apiRequestService.postCallWithAPIMapper(URL, obj).subscribe(resp => {
        if (resp && Object.entries(resp).length > 0) {
          this.submitting = false
          this.inputValue = null
          this.ServerToUITransform(this.inputDataForEdit);
        }
      })
    }
  }

  replyToCollaboration(currentCollabGuid, collaborationTypeCd, index) {
    this.replyToEnquiry(currentCollabGuid, collaborationTypeCd, index);
    this.notes[index] = null
    this.inputValue = null
  }

  getCollaborationNum(payload) {
    let DO = this.commonUtilty.getDOName(payload)
    if (payload && payload[DO])
      this.transactionGuid = payload[DO].guid
  }
  loggedInUser;
  loggedInUserRole
  roleCollabPartyMap={}

  ServerToUITransform(payload) {
    this.dataList=[]
    this.loggedInUser = this.userInfoService.getUserId()
    this.loggedInUserRole = this.userInfoService.getUserRoleDO().roleId
    let userWiseCollabList = []
    if (payload && this.commonUtilty.isArrayIterable(payload)) {
      if (Object.keys(this.roleCollabPartyMap).includes(this.loggedInUserRole)){
        payload.forEach(item=>{
          if(item.createdUser == this.loggedInUser ||  this.roleCollabPartyMap[this.loggedInUserRole] == item.followupPartyCd)
            userWiseCollabList.push(item) 
        })
      }
      else
        userWiseCollabList = payload
      userWiseCollabList.forEach((followupDO,index) => {
        let collab = followupDO['collaborationDO']
        let message;
        let msgList = []
        let dataObject = { status: null, collaborationTypeCd: null, requestedTs: null, collaborationPartyCd: null, categoryCd: null, data: [],guid:null,isReadOnly:true,panel : false,chasers:[]}
          message = new messageDO()
          message.content = collab['requestRemarks'];
          message.datetime = collab['requestedTs'];
          message.author = collab['createdUser'];
          message.displayTime = moment(collab['requestedTs']).format('llll');
          message.isRemarksFor = true;
          message.status = collab.statusCd
          message.guid = collab.guid
          message.showChaser=true
          message.conversations=collab.conversations
          message.isMsgChainEnd=true
          msgList.push(message)
        dataObject.status = collab.statusCd
        dataObject.guid = collab.guid
        dataObject.requestedTs = this.commonUtilty.serverDOtoUIDODate(collab.requestedTs)
        dataObject.collaborationTypeCd = collab.typeCd ? collab.typeCd : ''
        dataObject.collaborationPartyCd = collab.collaborationPartyCd ? collab.collaborationPartyCd : ''
        dataObject.categoryCd = collab.categoryCd ? collab.categoryCd : ''
        dataObject.data = msgList
        dataObject.chasers=collab.chasers
        this.dataList.push(dataObject)
      });
    }
  }

  note: any
  referTaskVis = false
  currentCollabGuid
  taskHeaderName = "No Reply"
  noReply(collabGuid, name) {
    this.modalName = name
    this.currentCollabGuid = collabGuid
    this.referTaskVis = true
  }
  cancelTask() {
    this.referTaskVis = false
  }
  _openingCase
  markAsNoReply(name) {
    if (this._openingCase) return false
    this._openingCase = true
    this.reply(name)
  }

  reply(name) {
    this.referTaskVis = false
    let reply = this.pushMessagetoArray()
    console.log(reply)
    let url = 'collaborationNoreply'
    if (name == "Reply")
      url = 'collaborationReply'
    this.apiRequestService.postCallWithAPIMapper(url, reply).subscribe(value => {
      if (value) {
        this._openingCase = true
        if (name == "Reply")
          this.msg.success("Reply successfully")
        else
          this.msg.success("Collaboration up completed. No Reply were recieved.")
        this.router.navigate(['/app/nbu/inbox/workbench'])
      }
    })
  }

  pushMessagetoArray() {
    let message1 = new messageDO()
    message1.message = this.note
    message1.guid = this.currentCollabGuid
    this.messageArray.push(message1)
    let inputDataForEditCopy = this.commonUtilty.deepCopy(this.inputDataForEdit)
    let indexval = 0
    if (this.commonUtilty.isArrayIterable(inputDataForEditCopy)) {
      inputDataForEditCopy.forEach((item, index) => {
        if (item.collaborationDO.guid == this.currentCollabGuid) {
          indexval = index
          let obj = {}
          obj = {
            "description": message1.message,
            "statusReasonDesc": message1.message,
            "createdUser": this.user ? this.user.author : '',
            "createdDt": new Date().getTime()
          }
          if (item.collaborationDO && this.commonUtilty.isArrayIterable(item.collaborationDO.conversations)) {
            inputDataForEditCopy[index].collaborationDO.conversations.push(obj)
          }
          else
            inputDataForEditCopy[index]['collaborationDO']['conversations'] = [obj]
        }
      });
    }

    if (this.commonUtilty.isArrayIterable(inputDataForEditCopy)) {
      let obj = inputDataForEditCopy.find(item => item.collaborationDO.guid == this.currentCollabGuid)
      let collaborationIO = { "collaborationDO": {} }
      if (obj) {
        collaborationIO.collaborationDO = obj.collaborationDO
      }
    }

    let collabObj = {
      "collaborationDO":
        inputDataForEditCopy[indexval].collaborationDO,
      "documents": []
    }
    return collabObj
  }

  modalName = null
  currentCollabTypeCd = null
  openReplyModule(currentCollabGuid, name, collaborationTypeCd) {
    this.modalName = name
    this.currentCollabGuid = currentCollabGuid
    this.currentCollabTypeCd = collaborationTypeCd
    this.referTaskVis = true
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  editorMaxLength(note) {
    if (note && note.length > 2000) {
      note = note.substring(0, 2000)
      const element = document.getElementById("editorData"); // Replace with your element ID

      // Listen for the 'paste' event on the element
      element.addEventListener("paste", function (event) {
        console.log("Paste event detected!");
        event.preventDefault()

        // You can also check what is being pasted:
        const pastedContent = event.clipboardData.getData("text");
        console.log("Pasted content:", pastedContent);

        // Optionally, prevent the default action (if needed)
        // event.preventDefault();
      });
      element.addEventListener("keydown", function (event: KeyboardEvent) {
        if (!([8, 33, 34, 35, 36, 37, 38, 39, 40, 44, 46].includes(event.keyCode)))
          event.preventDefault()

      });
    }
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: false,

  };

}